import { jaJP } from "@mui/material/locale";
import { ThemeOptions, createTheme } from "@mui/material/styles";

import { appColor } from "./app-colors";

// Material-UIパーツのテーマ
export const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: appColor.App.primary,
    },
    secondary: {
      main: appColor.Text.gray,
    },
    error: {
      main: "#DE3E44",
    },
    background: {
      default: "#fff",
    },
  },
};

export const muiTheme = createTheme(themeOptions, jaJP);
